import React from "react";
import ContactUs from "../../pages/components/contact/ContactUs";
import BottomMenu from "../../pages/components/contact/BottomMenu";

import "./footer.css";
import SocialMediaMenu from "./SocialMediaMenu";
import UseFullLinks from "./UseFullLinks";

const Footer = () => {
  const date = new Date();

  return (
    <div className=" ">
      <div className="relative ">
        <div className="footer-container">
          <div className="grid lg:grid-cols-4 gap-10 md:grid-cols-2 sm:grid-cols-1 max-sm:grid-cols-1 sm:gap-4 max-sm:gap-4  ">
            <ContactUs />
            <BottomMenu />
            <UseFullLinks />
            <SocialMediaMenu />
          </div>
        </div>
        <div className="bg-forging-yellow py-4 px-4 text-white font-sm  absolute bottom-0 w-full flex flex-row items-center  justify-between lg:justify-between lg:items-center lg:flex md:flex-col sm:flex-col max-sm:flex-col ">
          <p className="text-md sm:text-md max-sm:text-sm">
            {" "}
            &copy; {date.getFullYear()} Aswin Cold Forge. All Rights Reserved
          </p>
          <p className="text-md sm:text-md max-sm:text-sm">
            Developed by Keel Info Solution
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
